import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _Translate, _Translate2, _IngramLogoBlackWithR;
import React from 'react';
import { Translate } from '@im/react-localization';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FooterLinks } from './FooterLinks';
import { IngramSocials } from '@im/ui-lib/IngramSocials';
import { IngramLogoBlackWithRX4C } from '../../icons/IngramLogoBlackWithRX4C';
import { useIsDown } from '../../responsive';
import { CopyRight } from './CopyRight';
import { IngramAppStore } from '@im/ui-lib/IngramAppStore';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FooterIngram(props) {
  var appStore = props.appStore,
    copyRightLinks = props.copyRightLinks,
    footerColumns = props.footerColumns,
    socialMedias = props.socialMedias;
  var isDownSm = useIsDown('sm');
  return /*#__PURE__*/_jsxs(RootStack, {
    "data-testid": "footer-ingram",
    "data-element": "RootStack",
    "data-component": "FooterIngram",
    "data-source-file": "FooterIngram.tsx",
    children: [/*#__PURE__*/_jsxs(Grid, {
      container: true,
      gap: '36px',
      justifyContent: 'space-between',
      sx: {
        ml: '8px'
      },
      wrap: "nowrap",
      "data-element": "Grid",
      "data-source-file": "FooterIngram.tsx",
      children: [footerColumns && footerColumns.map(function (column, index) {
        return /*#__PURE__*/_jsxs(Grid, {
          item: true,
          md: 4,
          sm: 4,
          xl: 3,
          children: [/*#__PURE__*/_jsx(Typography, {
            component: "div",
            "data-testid": "footer-".concat(column.footerColumn.name),
            noWrap: true,
            sx: {
              fontSize: '18px',
              fontWeight: 600,
              mt: '16px'
            },
            variant: "h6",
            children: column.footerColumn.name
          }), /*#__PURE__*/_jsx(Divider, {
            style: isDownSm ? {
              margin: 'auto'
            } : {
              marginLeft: '0px',
              width: '80%'
            }
          }), /*#__PURE__*/_jsx(FooterLinks, {
            links: column.footerColumn.links
          })]
        }, "footer-".concat(column.footerColumn.name, "}"));
      }), /*#__PURE__*/_jsxs(Grid, {
        display: 'flex',
        flexDirection: {
          md: 'column',
          sm: 'column',
          xl: 'row'
        },
        gap: '36px',
        md: 4,
        sm: 4,
        xl: 6,
        "data-element": "Grid",
        "data-source-file": "FooterIngram.tsx",
        children: [socialMedias ? /*#__PURE__*/_jsxs(Grid, {
          item: true,
          md: 12,
          sm: 12,
          xl: 6,
          children: [/*#__PURE__*/_jsx(Typography, {
            align: isDownSm ? 'center' : 'left',
            component: "div",
            "data-testid": "footer-ShareYourStory",
            noWrap: true,
            sx: {
              fontSize: '18px',
              fontWeight: 600,
              mt: '16px'
            },
            variant: "h6",
            children: _Translate || (_Translate = /*#__PURE__*/_jsx(Translate, {
              text: "Footer.ShareYourStory"
            }))
          }), /*#__PURE__*/_jsx(Divider, {
            style: isDownSm ? {
              margin: 'auto'
            } : {
              marginLeft: '0px',
              width: '100%'
            }
          }), socialMedias && /*#__PURE__*/_jsx(IngramSocials, {
            socialMedias: socialMedias
          })]
        }) : null, appStore && (appStore == null ? void 0 : appStore.length) > 0 ? /*#__PURE__*/_jsxs(Grid, {
          item: true,
          md: 12,
          sm: 12,
          xl: 6,
          children: [/*#__PURE__*/_jsx(Typography, {
            align: isDownSm ? 'center' : 'left',
            component: "div",
            "data-testid": "footer-downloadApp",
            noWrap: true,
            sx: {
              fontSize: '18px',
              fontWeight: 600,
              mt: '16px'
            },
            variant: "h6",
            children: _Translate2 || (_Translate2 = /*#__PURE__*/_jsx(Translate, {
              text: "Footer.downloadApp"
            }))
          }), /*#__PURE__*/_jsx(Divider, {
            style: isDownSm ? {
              margin: 'auto'
            } : {
              marginLeft: '0px',
              width: '100%'
            }
          }), appStore && /*#__PURE__*/_jsx(IngramAppStore, {
            appStore: appStore
          })]
        }) : null]
      })]
    }), /*#__PURE__*/_jsx(Divider, {
      style: {
        marginLeft: '8px'
      },
      "data-element": "Divider",
      "data-source-file": "FooterIngram.tsx"
    }), /*#__PURE__*/_jsx(Box, {
      style: {
        marginBottom: '10px',
        marginLeft: '8px',
        marginTop: '25px'
      },
      sx: {
        flexGrow: 1
      },
      "data-element": "Box",
      "data-source-file": "FooterIngram.tsx",
      children: /*#__PURE__*/_jsxs(Grid, {
        container: true,
        "data-element": "Grid",
        "data-source-file": "FooterIngram.tsx",
        children: [/*#__PURE__*/_jsx(Grid, {
          item: true,
          md: 4,
          sm: 4,
          sx: {
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain'
          },
          xs: 4,
          "data-element": "Grid",
          "data-source-file": "FooterIngram.tsx",
          children: _IngramLogoBlackWithR || (_IngramLogoBlackWithR = /*#__PURE__*/_jsx(IngramLogoBlackWithRX4C, {
            "data-element": "IngramLogoBlackWithRX4C",
            "data-source-file": "FooterIngram.tsx"
          }))
        }), copyRightLinks && /*#__PURE__*/_jsx(Grid, {
          item: true,
          justifyContent: {
            md: 'end',
            sm: 'end',
            xs: 'end'
          },
          md: 8,
          sm: 8,
          xs: 8,
          children: /*#__PURE__*/_jsx(CopyRight, {
            copyRightLinks: copyRightLinks
          })
        })]
      })
    })]
  });
}
var RootStack = styled(Stack)(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    background: theme.palette.grey['A100'],
    color: theme.palette.common.black,
    marginLeft: '32px',
    marginRight: '32px',
    padding: theme.spacing(3, 3)
  }, theme.breakpoints.down('sm'), {
    textAlign: 'center'
  });
});